export const PROGRESS_INNER_BAR = 'inner-bar';
export const PROGRESS_ESTIMATE_BAR = 'estimate-bar';